export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export const updateSEO = (data: SEOData) => {
  // Update title
  document.title = data.title;

  // Update or create meta tags
  const updateMetaTag = (name: string, content: string, isProperty = false) => {
    const attribute = isProperty ? 'property' : 'name';
    let element = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', content);
  };

  // Update basic meta tags
  updateMetaTag('description', data.description);
  updateMetaTag('keywords', data.keywords);

  // Update Open Graph tags
  updateMetaTag('og:title', data.title, true);
  updateMetaTag('og:description', data.description, true);
  updateMetaTag('og:url', data.canonical, true);
  
  if (data.ogImage) {
    updateMetaTag('og:image', data.ogImage, true);
  }

  // Update Twitter tags
  updateMetaTag('twitter:title', data.title, true);
  updateMetaTag('twitter:description', data.description, true);
  
  if (data.ogImage) {
    updateMetaTag('twitter:image', data.ogImage, true);
  }

  // Update canonical link
  let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = data.canonical;

  // Add or update Schema.org JSON-LD
  if (data.schema) {
    let schemaScript = document.querySelector('script[type="application/ld+json"][data-page-schema]');
    
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.setAttribute('type', 'application/ld+json');
      schemaScript.setAttribute('data-page-schema', 'true');
      document.head.appendChild(schemaScript);
    }
    
    schemaScript.textContent = JSON.stringify(data.schema);
  }
};

export const getBaseUrl = (): string => {
  return 'https://bursasulamasistemleri.com';
};
